export enum actionTypes {
    SET_LANG = 'USER:LANG:SET',
    SET_COUNTRY = 'USER:COUNTRY:SET',
    SET_COUNTRY_BY_GEO_IP = 'USER:GEO_IP_COUNTRY:SET',
    SET_GEO_DATA = 'USER:GEO_DATA:SET',
    SET_DETAILS = 'USER:DETAILS:SET',
    SET_CLIENT_IP = 'USER:CLIENT_IP:SET',
    SET_IS_ALIVE = 'USER:IS_ALIVE:SET',
    TOGGLE_BALANCE = 'USER:BALANCE:TOGGLE',
    SET_ATTRIBUTES = 'USER:ATTRIBUTES:SET',
    UNSET_ATTRIBUTE = 'USER:ATTRIBUTE:UNSET',
    RESET_TO_DEFAULT = 'USER:RESET_TO_DEFAULT',
    SET_CURRENCY_CODE = 'USER:CURRENCY_CODE:SET',
    SET_LEGACY_USER_DATA = 'USER:LEGACY_DATA:SET',
    SET_CU_BALANCE = 'USER:CU_BALANCE:SET'
}
